import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/LandingView.tsx");
